module.exports = __webpack_public_path__ + "static/three-business-owners-mobile.b4c087a5.webp";